module.exports = __webpack_public_path__ + "img/A高通锐化50.98426c54.png";